module.exports = __webpack_public_path__ + "img/20191206164933360截图20191206103329887.e87bd29a.jpg";